import _extends from "@babel/runtime/helpers/extends";
import { jsx as ___EmotionJSX } from "@emotion/core";
import React from 'react';

var _ref =
/*#__PURE__*/
___EmotionJSX("path", {
  d: "M30 0H2a2 2 0 0 0-2 2v10.308C0 17.5 9.333 27.24 14 32h4c4.667-5.415 14-15.5 14-19.692V2a2 2 0 0 0-2-2z",
  fill: "#73C4FF"
});

var _ref2 =
/*#__PURE__*/
___EmotionJSX("path", {
  d: "M2 64h28a2 2 0 0 0 2-2V51.692C32 46.5 22.667 36.76 18 32h-4C9.333 37.415 0 47.5 0 51.692V62a2 2 0 0 0 2 2z",
  fill: "#C1E5FF"
});

var _ref3 =
/*#__PURE__*/
___EmotionJSX("path", {
  d: "M29 62H3a1 1 0 0 1-1-1v-1.818c0-.553.447-1.026.979-1.176C5.345 57.338 10.092 55 16 55s10.655 2.338 13.021 3.006c.532.15.979.623.979 1.176V61a1 1 0 0 1-1 1z",
  fill: "#73C4FF"
});

var SvgComponent = function SvgComponent(props) {
  return ___EmotionJSX("svg", _extends({
    width: 32,
    height: 64,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/faq-how-long.616460ae.svg";
export { SvgComponent as ReactComponent };